var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.name)?_c('span',{staticClass:"app-icon-container"},[_c(require(`@/core/assets/icons/${_vm.name}.svg`),{tag:"Component",staticClass:"app-icon"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }